import { render, staticRenderFns } from "./informe-autorreportes.vue?vue&type=template&id=5977b9e7&"
import script from "./informe-autorreportes.vue?vue&type=script&lang=js&"
export * from "./informe-autorreportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports